import React from 'react';
import * as styles from './aiEngineerFellowship.module.scss';

const FDE = ({ steps }) => {
  return (
    <section id="fde" className={styles.mint}>
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <span className={styles.eyebrow}>Problem → Production · the FDE layer</span>
          <h2>Learn To Decide What To Build — Not Just How</h2>
          <p>
            Forward-Deployed Engineers make AI work inside real organisations. We teach that work
            cycle — from problem framing to handover — and every guided project and the capstone
            practise it.
          </p>
        </div>
        <div className={styles.cards4}>
          {steps.map((step) => (
            <div className={styles.card} key={step.h}>
              <div className={styles.k}>{step.k}</div>
              <h4>{step.h}</h4>
              <p>{step.p}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FDE;
